import ToastHighLighter from '@/lib/ToastHighLighter';

export const LeadTextCode = () => {
  const language = 'html';
  const codeString = `
  // Lead text
  <p class="lead">
    Lorem ipsum <a href="#">dolor sit amet consectetur adipisicing elit</a>.
    Veritatis eos, commodi autem porro, ex quo odio illo quas nisi ratione
    sunt, delectus cum quam ad voluptatibus. Quia dolores natus veritatis
    veniam, officiis aperiam sed laboriosam consectetur repellendus commodi
    sit, exercitationem sint magni illo maxime fugiat blanditiis aut error
    quas odio mollitia minima ratione nostrum modi? Maxime ipsa nihil quasi
    excepturi assumenda eum! Iusto, beatae? Perspiciatis doloremque minus,
    explicabo nisi illo aspernatur. Eaque perferendis culpa dolores et
    mollitia, vero officiis. Praesentium eligendi nam quas distinctio ex
    doloribus minima odio! Eius doloremque nihil odit harum, non labore.
    Recusandae facere aliquam porro placeat?
  </p>

  // Optional lead text class (as in styleguide V4)
  <p class="text__lead">
    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Inventore,
    dolores! Impedit eveniet deleniti maiores tenetur eum officia vel eos,
    dignissimos cumque? Natus tempore earum facere porro a vel dolores
    dicta.
  </p>

  // Paragraph
  <p>
    Lorem ipsum <a href="#">dolor sit amet consectetur adipisicing elit</a>.
    Veritatis eos, commodi autem porro, ex quo odio illo quas nisi ratione
    sunt, delectus cum quam ad voluptatibus. Quia dolores natus veritatis
    veniam, officiis aperiam sed laboriosam consectetur repellendus commodi
    sit, exercitationem sint magni illo maxime fugiat blanditiis aut error
    quas odio mollitia minima ratione nostrum modi? Maxime ipsa nihil quasi
    excepturi assumenda eum! Iusto, beatae? Perspiciatis doloremque minus,
    explicabo nisi illo aspernatur. Eaque perferendis culpa dolores et
    mollitia, vero officiis. Praesentium eligendi nam quas distinctio ex
    doloribus minima odio! Eius doloremque nihil odit harum, non labore.
    Recusandae facere aliquam porro placeat?
  </p>
  `;

  return (
    <>
      <ToastHighLighter
        name={'leadtext'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const HeadingTags = () => {
  const language = 'html';
  const codeString = `
  // Heading Tags
  <h1>Pure heading tag without className</h1>
  <h2>Heading H2</h2>
  <h3>Heading H3</h3>
  <h4>Heading H4</h4>
  <h5>Heading H4</h5>
  <h6>Heading H4</h6>

  // Paragraph tag as heading
  <p class="h1">h1. Bootstrap heading with paragraph tag</p>
  <p class="h2">h2. Bootstrap heading with paragraph tag</p>
  <p class="h3">h3. Bootstrap heading with paragraph tag</p>
  <p class="h4">h4. Bootstrap heading with paragraph tag</p>
  <p class="h5">h5. Bootstrap heading with paragraph tag</p>
  <p class="h6">h6. Bootstrap heading with paragraph tag</p>
  `;

  return (
    <>
      <ToastHighLighter
        name={'headingtags'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const Listings = () => {
  const language = 'html';
  const codeString = `
  // Unordered list
  <ul class="mb-5">
    <li>Lorem ipsum dolor sit amet</li>
    <li>Consectetur adipiscing elit</li>
    <li>Integer molestie lorem at massa</li>
    <li>Facilisis in pretium nisl aliquet</li>
  </ul>

  // Ordered list
  <ol class="mb-5">
    <li>Lorem ipsum dolor sit amet</li>
    <li>Consectetur adipiscing elit</li>
    <li>Integer molestie lorem at massa</li>
    <li>Facilisis in pretium nisl aliquet</li>
  </ol>

  // Unstyled listing
  <ul class="list-unstyled mb-5">
    <li>Lorem ipsum dolor sit amet</li>
    <li>Consectetur adipiscing elit</li>
    <li>Integer molestie lorem at massa</li>
    <li>Facilisis in pretium nisl aliquet</li>
    <li>
      Nulla volutpat aliquam velit
      <ul>
        <li>Phasellus iaculis neque</li>
        <li>Purus sodales ultricies</li>
        <li>
          <ul>
            <li>Phasellus iaculis neque</li>
            <li>Purus sodales ultricies</li>
            <li>Vestibulum laoreet porttitor sem</li>
            <li>Ac tristique libero volutpat at</li>
          </ul>
        </li>
        <li>Ac tristique libero volutpat at</li>
      </ul>
    </li>
    <li>Faucibus porta lacus fringilla vel</li>
    <li>Aenean sit amet erat nunc</li>
    <li>Eget porttitor lorem</li>
  </ul>

  // Arrow list
  <ul class="list-arrow">
    <li>
      <a href="#">Lorem ipsum dolor sit amet.</a>
    </li>
    <li>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita,
      repellendus!
    </li>
  </ul>

  // Inline listing
  <ul class="list-inline">
    <li>Lorem ipsum dolor sit amet.</li>
    <li>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur,
      dolor.
    </li>
  </ul>
  `;

  return (
    <>
      <ToastHighLighter
        name={'unorderedlist'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
